import { render, staticRenderFns } from "./MainLedgerCard9.vue?vue&type=template&id=06fa07b2&scoped=true"
import script from "./MainLedgerCard9.vue?vue&type=script&lang=js"
export * from "./MainLedgerCard9.vue?vue&type=script&lang=js"
import style0 from "./otvoreneStavke.css?vue&type=style&index=0&id=06fa07b2&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fa07b2",
  null
  
)

export default component.exports